<template>
    <section id="trackpad_gestures" class="outer">
        <div class="inner">
            <header class="title">{{ title }}</header>
            <ul>
                <li v-for="gesture in gestures">{{ gesture }}</li>
            </ul>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                title: 'Trackpad gestures',
                gestures: [
                    'Tap with one finger to click.',
                    'Long press and move with one finger to drag window.',
                    'Tap with two fingers to secondary click.',
                    'Move with two fingers to scroll content in iPhone and iPad.',
                    'Rotate the Digital Crown to scroll content in Apple Watch.',
                    'Swipe up with three fingers to open Mission Control in iPhone and iPad.',
                    'Swipe down with three fingers to see all windows of the app you\'re using in iPhone and iPad.',
                    'Swipe left or right with three fingers to move between desktops and full-screen apps in iPhone and iPad.',
                    'Pinch your thumb and two fingers together to display Launchpad in iPhone and iPad.',
                    'Spread your thumb and two fingers apart to show your desktop in iPhone and iPad.'
                ]
            }
        }
    }
</script>

<style>
    #trackpad_gestures {
        padding-top: 40px;
        padding-bottom: 80px;
    }

    #trackpad_gestures .inner {
        max-width: 700px;
    }

    #trackpad_gestures ul {
        display: inline-block;
        text-align: left;
        list-style-type: circle;
    }
</style>



// WEBPACK FOOTER //
// src/components/TrackpadGestures.vue